import React, {Component} from 'react';
import {Button, Icon} from "semantic-ui-react";
import moment from "moment";
import {opacityFromDate} from "../../utils";
import {connect} from "react-redux";
import * as InteractiveMapActions from "../../actions/InteractiveMapActions";

class DateLegend extends Component {

    static color(date, now, fullMonth) {
        let opacity = opacityFromDate(date, now, fullMonth);
        return "rgba(51, 195, 189, " + opacity + ")";
    }

    nextMonth() {
        const {period, setDatePeriod} = this.props;

        let date = moment(period.date).startOf("month").add(1, "month");

        setDatePeriod({
            date,
            fullMonth: true,
        })

    }

    previousMonth() {
        const {period, setDatePeriod} = this.props;

        let date = moment(period.date).startOf("month").subtract(1, "month");

        setDatePeriod({
            date,
            fullMonth: true,
        })
    }

    render() {

        const {period} = this.props;
        // const {now} = this.state;

        const now = period.date;
        const fullMonth = period.fullMonth;

        // let firstMonth = moment(now).startOf("month").subtract("1", "months");
        // let secondMonth = moment(firstMonth).add("1", "months").startOf("month");
        // let secondMonth2 = moment(firstMonth).add("2", "months").startOf("month");
        let firstMonth = moment(now);
        let secondMonth = moment(firstMonth).add("1", "months").startOf("month");
        let secondMonth2 = moment(firstMonth).add("2", "months").startOf("month");

        let currentMonthBarWidth = now.diff(moment(firstMonth).startOf("month"), "months", true) * 100;
        let firstMonthIsCurrentMonth = firstMonth.isSame(moment(), "month");

        let backgroundFirstMonth = "linear-gradient(to right, " + DateLegend.color(firstMonth, now, fullMonth) + ", " + DateLegend.color(moment(firstMonth).endOf("month"), now, fullMonth) + ")";
        let backgroundSecondMonth = "linear-gradient(to right, " + DateLegend.color(secondMonth, now, fullMonth) + ", " + DateLegend.color(moment(secondMonth).endOf("month"), now, fullMonth) + ")";
        let backgroundSecondMonth2 = "linear-gradient(to right, " + DateLegend.color(secondMonth2, now, fullMonth) + ", " + DateLegend.color(moment(secondMonth2).endOf("month"), now, fullMonth) + ")";

        return <div className="date-legend-container">
            <div className="date-legend-inner-container">
                <h3>Departure:</h3>
                <Button.Group className="date-legend">
                    <Button icon onClick={() => this.previousMonth()}>
                        <Icon name='arrow left'/>
                    </Button>
                    <Button basic
                            className={"month first show-right-border" + (firstMonthIsCurrentMonth ? " current-month" : "")}>
                        {firstMonth.format("MMMM")}
                        {firstMonthIsCurrentMonth && <div className="current-month-bar"/>}
                        <div className="bar" style={{
                            background: backgroundFirstMonth,
                            left: firstMonthIsCurrentMonth ? currentMonthBarWidth + "%" : 0
                        }}/>
                    </Button>
                    <Button basic className="month show-right-border">
                        {secondMonth.format("MMMM")}
                        <div className="bar" style={{background: backgroundSecondMonth}}/>
                    </Button>
                    <Button basic className="month">
                        {secondMonth2.format("MMMM")}
                        <div className="bar" style={{background: backgroundSecondMonth2}}/>
                    </Button>
                    <Button icon onClick={() => this.nextMonth()}>
                        <Icon name='arrow right'/>
                    </Button>
                </Button.Group>
            </div>
        </div>;
    }
}


export default connect(state => ({
    period: state.interactiveMap.period,
}), dispatch => ({
    setDatePeriod: (params) => dispatch(InteractiveMapActions.setDatePeriod(params)),
}))(DateLegend)


// WEBPACK FOOTER //
// ./src/components/interactive-map/dateLegend.js